import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OpcaoComboService {
  constructor(private http: HttpClient) {}

  show(id: number): Observable<{}> {
    return this.http.get(environment.apiUrl + '/opcoes-combo/' + id);
  }
}
